import { APIClient } from "api/apiCore";
import { Utils } from "helpers/utils";
import * as urls from "../api/urls";
import { useEffect, useState } from "react";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { getCurrentUserAction } from "../redux/profile2/p2_reducer";
import { Capacitor } from "@capacitor/core";

interface ChangeViewAsProps {
  children: any;
  changeToId: number | null;
  changeToName: string;
  // onChangeViewAs: (changeToId: any, changeToName: any) => void;
}

const ChangeViewAs = ({ /*onChangeViewAs,*/ children, changeToId, changeToName }: ChangeViewAsProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state) => ({
      viewAsUserId: state.viewAsUserId,
    })
  );
  const { viewAsUserId } = useAppSelector(storeData);
  const [isSettingViewAs, setIsSettingViewAs] = useState<boolean>(false);

  useEffect(() => {
    if (isSettingViewAs) {
      // iOS WKWebView (standalone PWA) can stall if reload() runs synchronously
      // right after the SweetAlert2 modal + redux-saga promise chain settles;
      // deferring to the next tick lets it release the modal/paint state first.
      setTimeout(() => window.location.reload(), 0);
    }
    // Depends on viewAsUserId, not userId: /me's data.userId is always the real underlying
    // account - switching "view as" only changes data.viewAsUserId (see fnSetUser in
    // p2_reducer.ts). Watching userId here meant this effect never re-ran on a switch,
    // since that value never actually changes.
  }, [viewAsUserId]);

  const onViewAsCustomerClick = () => {
    try {
      const api = new APIClient();
      const isNative = true; // TODO TESTING: force token flow on web too, revert to Capacitor.isNativePlatform() before shipping
      const changeToCViewUrl = isNative ? urls.CHANGE_TO_CVIEW2 : urls.CHANGE_TO_CVIEW;
      if (changeToId) {
        Utils.SweetConfirm(`เปลี่ยนเป็นมุมมองของลูกค้า <br/><span class="text-red">${changeToName}</span><br/>ใช่หรือไม่`)
          .then((result) => {
            if (result.isConfirmed) {
              // console.log('member:', member);
              api.fnPostForm(changeToCViewUrl, { toUserId: changeToId })
                .then((rs) => {
                  if (rs.success) {
                    // navigate('/auth-login');
                    console.log('set view as = ' + changeToId);
                    if (isNative) Utils.VasTokenSet(rs.data); // native has no cookie, keep token to send as X-Vas-Token
                    setIsSettingViewAs(true);
                    dispatch(getCurrentUserAction());
                    // window.location.reload();
                    // console.log('rs:', rs);
                  } else {
                    alert(rs.message);
                  }
                })
                .catch((error) => { Utils.HandleException(error, true); });
              // dispatch(delUserFromGroup(member.groupId, userId));
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      } else {
        // exiting view-as has no server-side state to clean up (no cookie to clear for the token flow),
        // so on native, discard the token and refresh locally regardless of how the server call goes —
        // don't let a failed/errored round-trip strand the user in view-as mode forever
        const exitLocally = () => {
          Utils.VasTokenSet(null);
          setIsSettingViewAs(true);
          dispatch(getCurrentUserAction());
        };
        api.fnPostForm(changeToCViewUrl, { toUserId: null })
          .then((rs) => {
            if (rs.success) {
              if (isNative) {
                exitLocally();
              } else {
                setIsSettingViewAs(true);
                dispatch(getCurrentUserAction());
              }
              //navigate('/auth-login');
              // window.location.reload();
              // console.log('rs:', rs);
            } else {
              alert(rs.message);
              if (isNative) exitLocally();
            }
          })
          .catch((error) => {
            Utils.HandleException(error, true);
            if (isNative) exitLocally();
          });
      }
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }

  return (
    <>
      <span onClick={onViewAsCustomerClick}>
        {children}
      </span>
    </>
  );
};

export default ChangeViewAs;
